<div class="row mb-4">
  <div class="col-12">
    <app-equipamento-kpi-grid [items]="kpiItems" [columns]="6"></app-equipamento-kpi-grid>
  </div>
</div>

<p-menu #rowMenu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>

<!-- Header controls (Search & Filter) -->
<div class="maintenance-header-controls">

  <div class="search-box">
    <i class="ri-search-line search-icon"></i>
    <input type="text" pInputText [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
      placeholder="Pesquisar matrícula, tipo de serviço, oficina..." class="search-input" />
  </div>

  <div class="filter-pills-container">
    <button class="filter-pill" [class.active]="activeFilter === 'Todas'" (click)="setFilter('Todas')">
      Todas
    </button>
    <button class="filter-pill" [class.active]="activeFilter === 'Em Curso'" (click)="setFilter('Em Curso')">
      <span class="pill-dot dot-amber"></span> Em Curso
    </button>
    <button class="filter-pill" [class.active]="activeFilter === 'Agendada'" (click)="setFilter('Agendada')">
      <span class="pill-dot dot-blue"></span> Agendada
    </button>
    <button class="filter-pill" [class.active]="activeFilter === 'Concluída'" (click)="setFilter('Concluída')">
      <span class="pill-dot dot-green"></span> Concluída
    </button>
    <button class="filter-pill" [class.active]="activeFilter === 'Aguarda Peças'" (click)="setFilter('Aguarda Peças')">
      <span class="pill-dot dot-orange"></span> Aguarda Peças
    </button>
  </div>

  <div class="action-btn-container">
    <button class="btn-nova-manutencao" (click)="openCreate()">
      <i class="ri-add-line"></i> Nova Manutenção
    </button>
  </div>

</div>

<!-- Data Table -->
<div class="data-table-wrapper">
  <table class="data-table">
    <thead>
      <tr>
        <th class="ps-4">REF.</th>
        <th>VIATURA</th>
        <th>TIPO DE INTERVENÇÃO</th>
        <th>DATA ENTRADA</th>
        <th>DATA SAÍDA</th>
        <th>KM</th>
        <th>OFICINA</th>
        <th>CUSTO (AOA)</th>
        <th>ESTADO</th>
        <th class="text-end pe-4">AÇÕES</th>
      </tr>
    </thead>
    <tbody>
      <!-- Loading state -->
      <ng-container *ngIf="loading">
        <tr *ngFor="let item of [1,2,3,4,5]">
          <td class="ps-4"><p-skeleton width="75px" height="18px"></p-skeleton></td>
          <td>
            <p-skeleton width="95px" height="22px" borderRadius="6px" styleClass="mb-1"></p-skeleton>
            <p-skeleton width="110px" height="13px"></p-skeleton>
          </td>
          <td>
            <p-skeleton width="140px" height="18px" styleClass="mb-1"></p-skeleton>
            <p-skeleton width="180px" height="13px"></p-skeleton>
          </td>
          <td><p-skeleton width="80px" height="18px"></p-skeleton></td>
          <td><p-skeleton width="90px" height="18px"></p-skeleton></td>
          <td><p-skeleton width="70px" height="18px"></p-skeleton></td>
          <td>
            <p-skeleton width="110px" height="18px" styleClass="mb-1"></p-skeleton>
            <p-skeleton width="90px" height="13px"></p-skeleton>
          </td>
          <td>
            <p-skeleton width="80px" height="18px" styleClass="mb-1"></p-skeleton>
            <p-skeleton width="50px" height="13px"></p-skeleton>
          </td>
          <td><p-skeleton width="95px" height="24px" borderRadius="16px"></p-skeleton></td>
          <td class="text-end pe-4"><p-skeleton width="90px" height="28px" borderRadius="8px"
              styleClass="ms-auto"></p-skeleton></td>
        </tr>
      </ng-container>

      <!-- Empty state -->
      <tr *ngIf="!loading && filteredRows.length === 0">
        <td colspan="10" class="text-center py-5">
          <app-empty-state icon="ri-tools-line" title="Sem manutenções encontradas"
            description="Não foram encontradas manutenções com os filtros atuais." actionLabel="Nova Manutenção"
            (action)="openCreate()"></app-empty-state>
        </td>
      </tr>

      <!-- Data rows -->
      <tr *ngFor="let row of filteredRows" class="clickable-row" (click)="openVerDetalhe(row)">
        <!-- 1. Ref -->
        <td class="ps-4 align-middle">
          <span class="ref-code">{{ getRef(row) }}</span>
        </td>

        <!-- 2. Viatura -->
        <td class="align-middle">
          <div class="viatura-col">
            <span class="viatura-matricula-pill">{{ getEquipamentoInfoCache(row.equipamentoId).matricula }}</span>
            <span class="viatura-sub">{{ getEquipamentoInfoCache(row.equipamentoId).marca }} {{
              getEquipamentoInfoCache(row.equipamentoId).modelo }}</span>
          </div>
        </td>

        <!-- 3. Tipo de Intervenção -->
        <td class="align-middle">
          <div class="intervencao-col">
            <strong class="intervencao-title">{{ getTipoLabel(row.manutencaoTipoEnum) }}</strong>
            <span class="intervencao-desc" [pTooltip]="row.descricaoServico || row.observacoes"
              tooltipPosition="top">
              {{ row.descricaoServico || 'Manutenção programada' }}
            </span>
          </div>
        </td>

        <!-- 4. Data Entrada -->
        <td class="align-middle">
          <span class="data-text">{{ formatDate(row.dataEntrada || row.dataManutencao) }}</span>
        </td>

        <!-- 5. Data Saída / Previsão -->
        <td class="align-middle">
          <span [ngClass]="getDataSaidaInfo(row).cssClass">
            {{ getDataSaidaInfo(row).text }}
          </span>
        </td>

        <!-- 6. Km -->
        <td class="align-middle">
          <span class="km-text">{{ formatKm(row.quilometragemOuHorasUso) }}</span>
        </td>

        <!-- 7. Oficina -->
        <td class="align-middle">
          <div class="oficina-col">
            <span class="oficina-nome">{{ getOficinaNome(row) }}</span>
            <span class="oficina-contacto" *ngIf="getOficinaContacto(row)">{{ getOficinaContacto(row) }}</span>
          </div>
        </td>

        <!-- 8. Custo (AOA) -->
        <td class="align-middle">
          <div class="custo-col" *ngIf="!isConcluida(row)">
            <span class="custo-est">Est: {{ getCustoEstimado(row) }}</span>
            <span class="custo-real-sub">Real: {{ getCustoReal(row) }}</span>
          </div>
          <div class="custo-col" *ngIf="isConcluida(row)">
            <strong class="custo-concluido">{{ getCustoValorPrincipal(row) }}</strong>
            <span class="custo-pago"><i class="ri-check-line"></i> Pago</span>
          </div>
        </td>

        <!-- 9. Estado -->
        <td class="align-middle">
          <span class="status-badge" [ngClass]="getEstadoInfo(row.manutencaoEstadoEnum).badgeClass">
            <span class="status-dot" [ngClass]="getEstadoInfo(row.manutencaoEstadoEnum).dotClass"></span>
            {{ getEstadoInfo(row.manutencaoEstadoEnum).label }}
          </span>
        </td>

        <!-- 10. Ações -->
        <td class="text-end pe-4 align-middle" (click)="$event.stopPropagation()">
          <button class="btn-dots" type="button" (click)="openRowMenu($event, row)"
            title="Ações da manutenção">
            <i class="pi pi-ellipsis-v"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- ============================================== -->
<!-- DRAWER: CRIAR/EDITAR MANUTENÇÃO -->
<!-- ============================================== -->
<p-drawer [(visible)]="drawerVisible" position="right" styleClass="maintenance-drawer"
  [header]="editingId ? 'Editar Manutenção' : 'Nova Manutenção'" (onHide)="closeDrawer()">

  <div class="drawer-body" *ngIf="drawerVisible">

    <div class="form-field">
      <label class="form-label required">Viatura</label>
      <p-select [options]="availableEquipamentosOpcoes" [(ngModel)]="form.equipamentoId"
        placeholder="Selecione a viatura" [filter]="true" filterBy="label" [disabled]="!!editingId">
      </p-select>
      <small class="text-danger" *ngIf="submitted && !form.equipamentoId">
        Selecione uma viatura.
      </small>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="form-label required">Tipo de Intervenção</label>
        <p-select [options]="tipos" [(ngModel)]="form.manutencaoTipoEnum" placeholder="Selecione o tipo">
        </p-select>
        <small class="text-danger" *ngIf="submitted && form.manutencaoTipoEnum === null">
          Obrigatório.
        </small>
      </div>
      <div class="form-field">
        <label class="form-label required">Estado</label>
        <p-select [options]="estados" [(ngModel)]="form.manutencaoEstadoEnum">
        </p-select>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="form-label required">Data de Entrada</label>
        <p-datepicker [(ngModel)]="form.dataEntrada" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body">
        </p-datepicker>
        <small class="text-danger" *ngIf="submitted && !form.dataEntrada">
          Data de entrada é obrigatória.
        </small>
      </div>
      <div class="form-field">
        <label class="form-label">Previsão de Saída</label>
        <p-datepicker [(ngModel)]="form.dataPrevisaoSaida" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body">
        </p-datepicker>
      </div>
    </div>

    <div class="form-field">
      <label class="form-label">Descrição Resumida do Serviço</label>
      <input type="text" pInputText [(ngModel)]="form.descricaoServico" placeholder="Ex: Reparação — Travões" />
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="form-label">Custo Estimado (AOA)</label>
        <p-inputnumber [(ngModel)]="form.custoEstimado" mode="currency" currency="AOA" locale="pt-AO"
          placeholder="0,00">
        </p-inputnumber>
      </div>
      <div class="form-field">
        <label class="form-label">Quilometragem (Km)</label>
        <p-inputnumber [(ngModel)]="form.quilometragemOuHorasUso" placeholder="Ex: 78100">
        </p-inputnumber>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="form-label">Oficina (Nome)</label>
        <input type="text" pInputText [(ngModel)]="form.oficina" placeholder="Ex: MetalCar Luanda" />
      </div>
      <div class="form-field">
        <label class="form-label">Oficina (Contacto Telefónico)</label>
        <input type="text" pInputText [(ngModel)]="form.oficinaContacto" placeholder="Ex: +244 923 111 222" />
      </div>
    </div>

    <div class="form-field">
      <label class="form-label">Observações / Detalhes</label>
      <textarea pTextarea [(ngModel)]="form.observacoes" placeholder="Ex: Substituição pastilhas + discos"></textarea>
    </div>

    <div class="form-field">
      <label class="form-label">Anexar Documentos (Faturas, Relatórios)</label>
      <div class="file-upload-box" (click)="fileInput.click()">
        <i class="ri-upload-cloud-2-line upload-icon"></i>
        <p class="upload-text">Clique para selecionar ficheiros</p>
        <input #fileInput type="file" class="d-none" multiple (change)="onFileChange($event)" />
      </div>

      <div class="file-list" *ngIf="selectedFiles.length > 0">
        <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
          <i class="ri-file-line file-icon"></i>
          <span class="file-name">{{ file.name }}</span>
          <button class="btn btn-sm btn-icon btn-ghost-danger remove-btn" (click)="removeFile(i)">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>
    </div>

  </div>

  <div class="drawer-footer">
    <button class="btn btn-outline-secondary" (click)="closeDrawer()" [disabled]="saving">Cancelar</button>
    <button class="btn btn-primary" (click)="save()" [disabled]="saving">
      <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
      {{ editingId ? 'Atualizar' : 'Registar' }}
    </button>
  </div>
</p-drawer>


<!-- ============================================== -->
<!-- DRAWER: CONCLUIR MANUTENÇÃO -->
<!-- ============================================== -->
<p-drawer [(visible)]="concluirDrawerVisible" position="right" styleClass="maintenance-drawer"
  header="Concluir Intervenção" (onHide)="closeConcluirDrawer()">

  <div class="drawer-body" *ngIf="concluirDrawerVisible && concluindoRow">

    <div class="maintenance-summary-alert">
      <i class="ri-information-fill alert-icon"></i>
      <div class="alert-content">
        <h6 class="alert-title">
          {{ getEquipamentoInfo(concluindoRow.equipamentoId).matricula }} — {{
          getTipoLabel(concluindoRow.manutencaoTipoEnum) }}
        </h6>
        <p class="alert-desc">{{ concluindoRow.descricaoServico || 'Intervenção em curso' }}</p>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="form-label required">Data de Conclusão (Saída)</label>
        <p-datepicker [(ngModel)]="concluirForm.dataSaida" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body">
        </p-datepicker>
      </div>
      <div class="form-field">
        <label class="form-label">Quilometragem (Km) de Saída</label>
        <p-inputnumber [(ngModel)]="concluirForm.kmReal" placeholder="Ex: 78100">
        </p-inputnumber>
      </div>
    </div>

    <div class="form-field">
      <label class="form-label required">Custo Real Final (AOA)</label>
      <p-inputnumber [(ngModel)]="concluirForm.custoReal" mode="currency" currency="AOA" locale="pt-AO"
        placeholder="0,00">
      </p-inputnumber>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="form-label">Oficina Responsável</label>
        <input type="text" pInputText [(ngModel)]="concluirForm.oficina" />
      </div>
      <div class="form-field">
        <label class="form-label">Contacto da Oficina</label>
        <input type="text" pInputText [(ngModel)]="concluirForm.oficinaContacto" />
      </div>
    </div>

    <div class="form-field">
      <label class="form-label">Observações / Relatório Final</label>
      <textarea pTextarea [(ngModel)]="concluirForm.observacoes"
        placeholder="Descrição do trabalho efetuado na conclusão..."></textarea>
    </div>

    <div class="form-field">
      <label class="form-label">Anexar Fatura / Relatório de Oficina</label>
      <div class="file-upload-box" (click)="concluirFileInput.click()">
        <i class="ri-upload-cloud-2-line upload-icon"></i>
        <p class="upload-text">Clique para selecionar ficheiros</p>
        <input #concluirFileInput type="file" class="d-none" multiple (change)="onConcluirFileChange($event)" />
      </div>

      <div class="file-list" *ngIf="concluirSelectedFiles.length > 0">
        <div class="file-item" *ngFor="let file of concluirSelectedFiles; let i = index">
          <i class="ri-file-line file-icon"></i>
          <span class="file-name">{{ file.name }}</span>
          <button class="btn btn-sm btn-icon btn-ghost-danger remove-btn" (click)="removeConcluirFile(i)">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>
    </div>

  </div>

  <div class="drawer-footer">
    <button class="btn btn-outline-secondary" (click)="closeConcluirDrawer()"
      [disabled]="savingConclusao">Cancelar</button>
    <button class="btn btn-success" (click)="saveConclusao()" [disabled]="savingConclusao || !concluirForm.dataSaida">
      <span *ngIf="savingConclusao" class="spinner-border spinner-border-sm me-2"></span>
      Confirmar Conclusão
    </button>
  </div>
</p-drawer>


<!-- ============================================== -->
<!-- DRAWER: VER DETALHES DA MANUTENÇÃO -->
<!-- ============================================== -->
<p-drawer [(visible)]="detalheDrawerVisible" position="right" styleClass="maintenance-drawer detalhe-drawer"
  header="Detalhe da Manutenção" (onHide)="closeDetalheDrawer()">

  <div class="drawer-body" *ngIf="detalheDrawerVisible && detalheRow">

    <!-- Header info card -->
    <div class="detalhe-hero-card">
      <div class="dh-top">
        <div class="dh-ref-box">
          <span class="dh-ref">{{ getRef(detalheRow) }}</span>
          <span class="status-badge" [ngClass]="getEstadoInfo(detalheRow.manutencaoEstadoEnum).badgeClass">
            <span class="status-dot" [ngClass]="getEstadoInfo(detalheRow.manutencaoEstadoEnum).dotClass"></span>
            {{ getEstadoInfo(detalheRow.manutencaoEstadoEnum).label }}
          </span>
        </div>
        <div class="dh-tipo">{{ getTipoLabel(detalheRow.manutencaoTipoEnum) }}</div>
      </div>
      <h4 class="dh-service">{{ detalheRow.descricaoServico || 'Intervenção de Manutenção' }}</h4>
    </div>

    <!-- Viatura card -->
    <div class="detalhe-section-card">
      <div class="dsc-header">
        <i class="ri-car-line"></i>
        <span>Viatura</span>
      </div>
      <div class="dsc-grid">
        <div class="dsc-item">
          <span class="dsc-label">Matrícula</span>
          <span class="viatura-matricula-pill lg">{{ getEquipamentoInfoCache(detalheRow.equipamentoId).matricula
            }}</span>
        </div>
        <div class="dsc-item">
          <span class="dsc-label">Marca / Modelo</span>
          <strong class="dsc-val">{{ getEquipamentoInfoCache(detalheRow.equipamentoId).marca }} {{
            getEquipamentoInfoCache(detalheRow.equipamentoId).modelo }}</strong>
        </div>
        <div class="dsc-item">
          <span class="dsc-label">Quilometragem</span>
          <span class="dsc-val">{{ formatKm(detalheRow.quilometragemOuHorasUso) }}</span>
        </div>
      </div>
    </div>

    <!-- Cronologia e Datas -->
    <div class="detalhe-section-card">
      <div class="dsc-header">
        <i class="ri-calendar-line"></i>
        <span>Cronologia e Prazos</span>
      </div>
      <div class="dsc-grid">
        <div class="dsc-item">
          <span class="dsc-label">Data de Entrada</span>
          <strong class="dsc-val">{{ formatDate(detalheRow.dataEntrada || detalheRow.dataManutencao) }}</strong>
        </div>
        <div class="dsc-item">
          <span class="dsc-label">Previsão de Saída</span>
          <span class="dsc-val" [ngClass]="detalheRow.dataPrevisaoSaida ? 'text-saida-previsao' : ''">
            {{ detalheRow.dataPrevisaoSaida ? formatDate(detalheRow.dataPrevisaoSaida) : '—' }}
          </span>
        </div>
        <div class="dsc-item">
          <span class="dsc-label">Data de Saída</span>
          <span class="dsc-val" [ngClass]="detalheRow.dataSaida ? 'text-saida-concluida' : ''">
            {{ detalheRow.dataSaida ? formatDate(detalheRow.dataSaida) : '—' }}
          </span>
        </div>
      </div>
    </div>

    <!-- Custos -->
    <div class="detalhe-section-card">
      <div class="dsc-header">
        <i class="ri-money-dollar-circle-line"></i>
        <span>Custos e Faturação</span>
      </div>
      <div class="dsc-grid">
        <div class="dsc-item">
          <span class="dsc-label">Custo Estimado</span>
          <strong class="dsc-val">{{ getCustoEstimado(detalheRow) }} Kz</strong>
        </div>
        <div class="dsc-item">
          <span class="dsc-label">Custo Real Final</span>
          <strong class="dsc-val" [class.text-success]="isConcluida(detalheRow)">
            {{ getCustoReal(detalheRow) !== '—' ? (getCustoReal(detalheRow) + ' Kz') : '—' }}
          </strong>
        </div>
        <div class="dsc-item">
          <span class="dsc-label">Estado de Pagamento</span>
          <span class="custo-pago" *ngIf="isConcluida(detalheRow)"><i class="ri-check-line"></i> Pago</span>
          <span class="text-muted-dash" *ngIf="!isConcluida(detalheRow)">Pendente</span>
        </div>
      </div>
    </div>

    <!-- Oficina -->
    <div class="detalhe-section-card">
      <div class="dsc-header">
        <i class="ri-building-line"></i>
        <span>Oficina Responsável</span>
      </div>
      <div class="dsc-grid">
        <div class="dsc-item">
          <span class="dsc-label">Nome da Oficina</span>
          <strong class="dsc-val">{{ getOficinaNome(detalheRow) }}</strong>
        </div>
        <div class="dsc-item">
          <span class="dsc-label">Contacto</span>
          <span class="dsc-val">{{ getOficinaContacto(detalheRow) || '—' }}</span>
        </div>
      </div>
    </div>

    <!-- Observações -->
    <div class="detalhe-section-card" *ngIf="detalheRow.observacoes">
      <div class="dsc-header">
        <i class="ri-file-text-line"></i>
        <span>Observações e Relatório</span>
      </div>
      <p class="dsc-obs">{{ getObservacoesLimpas(detalheRow) || detalheRow.observacoes }}</p>
    </div>

    <!-- Anexos -->
    <div class="detalhe-section-card" *ngIf="detalheRow.anexos && detalheRow.anexos.length > 0">
      <div class="dsc-header">
        <i class="ri-attachment-line"></i>
        <span>Anexos ({{ detalheRow.anexos.length }})</span>
      </div>
      <div class="file-list">
        <div class="file-item" *ngFor="let anexo of detalheRow.anexos">
          <i class="ri-file-line file-icon"></i>
          <span class="file-name">{{ anexo.descricao || ('Anexo #' + anexo.id) }}</span>
        </div>
      </div>
    </div>

  </div>

  <div class="drawer-footer" *ngIf="detalheRow">
    <button class="btn btn-outline-secondary" (click)="closeDetalheDrawer()">Fechar</button>
    <button *ngIf="canEditar(detalheRow)" class="btn btn-outline-primary"
      (click)="closeDetalheDrawer(); openEdit(detalheRow)">
      <i class="ri-pencil-line me-1"></i> Editar
    </button>
    <button *ngIf="canConcluir(detalheRow)" class="btn btn-success"
      (click)="closeDetalheDrawer(); openConcluir(detalheRow)">
      <i class="ri-check-line me-1"></i> Concluir Manutenção
    </button>
  </div>
</p-drawer>